import { fromJS } from 'immutable'
import {
  EFFICIENCY_SUBMIT_REQUEST,
  EFFICIENCY_SUBMIT_SUCCESS,
  EFFICIENCY_SUBMIT_FAILURE,
  EFFICIENCY_SUBMIT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case EFFICIENCY_SUBMIT_REQUEST:
      return state
        .set('isFetching', true)
    case EFFICIENCY_SUBMIT_SUCCESS:
      return state
        .set('submittedEfficiencyResource', fromJS(action.payload.submittedEfficiencyResource))
        .set('status', 200)
        .set('message', 'Submitted Successfully.')
        .set('isFetching', false)
    case EFFICIENCY_SUBMIT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('submittedEfficiencyResource', fromJS(action.payload))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
    case EFFICIENCY_SUBMIT_RESET:
      return state
        .delete('submittedEfficiencyResource')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/efficiency-resource/efficiency-submit-reducer.js